import React, { Component } from 'react'
import {
  Breadcrumb, Button, Card, notification, Spin, Tabs, Tooltip,
} from 'antd'
import Parse from 'parse'
import Auth from '../../../../auth/Auth'
import { findById, save } from '../../../../utils/db_functions'
import ProductStep from '../../../commercial/proposal/components/proposal-steps/product-step'
import requiredFields from '../../../commercial/proposal/suport-files/required-fields'
import GeneralInfoReadonly from './general-info-readonly'
import {
  generateConsolidatedOrderAnaliticPdf,
  generateConsolidatedOrderPdf,
} from '../entities/pdf-actions'

export default class ConsolidatedOrderForm extends Component {
  state = {
    loading: true,
    saving: false,
    generatingPdf: false,
    generatingAnaliticPdf: false,
    data: {
      product_blocks: [],
      order_snapshot: {},
    },
    dataConfigs: {},
    required: requiredFields,
    disabledFields: false,
  }

  constructor(props) {
    super(props)
    this.auth = new Auth(Parse.User.current())
    this.auth.init(() => this.forceUpdate())
  }

  componentDidMount = async () => {
    const objectId = this.props.routerProps.match.params.objectId
    if (!objectId) {
      this.props.module.url_props.history.push('/panel/pedido-consolidado')
      notification.info({
        message: 'Criação pelo pedido',
        description: 'Gere o pedido consolidado a partir do formulário do Pedido.',
        placement: 'topLeft',
      })
      return
    }
    await this.loadData(objectId)
  }

  loadData = async (objectId) => {
    this.setState({ loading: true })
    const parseObject = await findById('ConsolidatedOrder', objectId)
    if (!parseObject) {
      notification.error({
        message: 'Registro não encontrado',
        placement: 'topLeft',
      })
      this.props.module.url_props.history.push('/panel/pedido-consolidado')
      return
    }
    const data = parseObject.toJSON()
    if (!data.product_blocks) data.product_blocks = []
    if (!data.order_snapshot) data.order_snapshot = {}
    this.setState({ loading: false, data, objectId })
  }

  getValue = (attr) => {
    if (this.state.data[attr] === 0) return 0
    return this.state.data[attr] || null
  }

  updateDataValue = (attr, value, callback = () => {}) => {
    this.setState(
      (state) => ({ data: { ...state.data, [attr]: value } }),
      callback
    )
  }

  navigateToList = () => {
    this.props.module.url_props.history.push('/panel/pedido-consolidado')
  }

  saveForm = async () => {
    this.setState({ saving: true })
    const saved = await save(
      'ConsolidatedOrder',
      { product_blocks: this.state.data.product_blocks },
      this.state.objectId
    )
    this.setState({ saving: false })
    if (!saved) {
      notification.error({
        message: 'Erro ao salvar',
        description: 'Não foi possível salvar o pedido consolidado.',
        placement: 'topLeft',
      })
      return
    }
    notification.success({
      message: 'Pedido consolidado salvo',
      placement: 'topLeft',
    })
  }

  handleGeneratePdf = async () => {
    this.setState({ generatingPdf: true })
    try {
      await generateConsolidatedOrderPdf(this.state.objectId)
    } catch (e) {
      // notification handled in helper
    } finally {
      this.setState({ generatingPdf: false })
    }
  }

  handleGenerateAnaliticPdf = async () => {
    this.setState({ generatingAnaliticPdf: true })
    try {
      await generateConsolidatedOrderAnaliticPdf(this.state.objectId)
    } catch (e) {
      // notification handled in helper
    } finally {
      this.setState({ generatingAnaliticPdf: false })
    }
  }

  render() {
    const canUpdate = this.auth.hasAction(['*', 'ConsolidatedOrderUpdate'])

    return (
      <Spin spinning={this.state.loading}>
        <Card
          title={
            <div>
              <Breadcrumb>
                <Breadcrumb.Item onClick={this.navigateToList}>
                  Pedido Consolidado
                </Breadcrumb.Item>
                <Breadcrumb.Item>Editar</Breadcrumb.Item>
              </Breadcrumb>
              <h2 className="no-mar-pad" style={{ float: 'left' }}>
                {this.state.data.code || 'Pedido Consolidado'}
              </h2>
              <div className="right-btns">
                <Button
                  icon="file-pdf"
                  loading={this.state.generatingPdf}
                  onClick={this.handleGeneratePdf}
                  style={{ marginRight: 8 }}
                >
                  Gerar PDF
                </Button>
                <Button
                  icon="file-pdf"
                  loading={this.state.generatingAnaliticPdf}
                  onClick={this.handleGenerateAnaliticPdf}
                  style={{ marginRight: 8 }}
                >
                  Gerar PDF Analítico
                </Button>
                {canUpdate && (
                  <Tooltip title="Salvar produtos">
                    <Button
                      type="primary"
                      icon="save"
                      loading={this.state.saving}
                      onClick={this.saveForm}
                    >
                      Salvar
                    </Button>
                  </Tooltip>
                )}
              </div>
            </div>
          }
        >
          <Tabs type="card">
            <Tabs.TabPane tab="Dados gerais" key="general">
              <GeneralInfoReadonly data={this.state.data} />
            </Tabs.TabPane>
            <Tabs.TabPane tab="Produtos" key="products">
              {!this.state.loading && (
                <ProductStep
                  getValue={this.getValue}
                  updateDataValue={this.updateDataValue}
                  disabledFields={!canUpdate || this.state.disabledFields}
                  required={this.state.required}
                  doorLocksMatriz={[]}
                  panelsMatriz={[]}
                  alizMatriz={[]}
                  alizarDataCK={[]}
                  auth={this.auth}
                  hideQrp
                  dataConfigs={this.state.dataConfigs}
                  setDataConfigs={(config) =>
                    this.setState((state) => ({
                      dataConfigs: { ...state.dataConfigs, ...config },
                    }))
                  }
                />
              )}
            </Tabs.TabPane>
          </Tabs>
        </Card>
      </Spin>
    )
  }
}
